import axios from 'axios';
import config from '../config';
import handleServiceResponse from '../hof/handleServiceResponse';

export class Posts {

    static publish = async (post, blogId) => {

        return await handleServiceResponse(async () => {
            const options = {
                url: `${config.API_ADDR}/blogs/${blogId}/posts`,
                method: 'POST',
                data: post
            };

            const { data } = await axios(options)
            return data;
        });

    }

    static remove = async (postId, blogId) => {

        return await handleServiceResponse(async () => {
            const options = {
                url: `${config.API_ADDR}/blogs/${blogId}/posts/${postId}`,
                method: 'DELETE'
            };

            const { data } = await axios(options)
            return data;
        });

    }

    static hide = async (postId, blogId) => {

        return await handleServiceResponse(async () => {
            const options = {
                url: `${config.API_ADDR}/blogs/${blogId}/posts/${postId}/hide`,
                method: 'PUT'
            };

            const { data } = await axios(options)
            return data;
        });

    }

    static unhide = async (postId, blogId) => {

        return await handleServiceResponse(async () => {
            const options = {
                url: `${config.API_ADDR}/blogs/${blogId}/posts/${postId}/unhide`,
                method: 'PUT'
            };

            const { data } = await axios(options)
            return data;
        });

    }

    static getPublished = async (blogId) => {
        return await handleServiceResponse(async () => {
            const options = {
                url: `${config.API_ADDR}/posts/${blogId}/published`,
                method: 'GET',
            }

            const { data } = await axios(options)
            return data.data;
        });

    }

    static getAllPaginated = async (blogId, page, limit, sortBy, order) => {

        return await handleServiceResponse(async () => {
            let url = `${config.API_ADDR}/blogs/${blogId}/posts?page=${page ? page - 1 : 0}&limit=${limit}`;

            if (sortBy) {
                url = `${url}&sortBy=${sortBy}`;
            } else {
                url = `${url}&sortBy=publishedAt`;
            }

            if (order) {
                url = `${url}&order=${order}`;
            }

            const options = {
                url,
                method: 'GET'
            };
            const { data } = await axios(options);
            return data;
        });
    }

    static getSingle = async (blogId, postId) => {
        return await handleServiceResponse(async () => {
            const options = {
                url: `${config.API_ADDR}/blogs/${blogId}/posts/${postId}`,
                method: 'GET'
            };

            const { data } = await axios(options)
            return data;
        });

    }

    static update = async (blogId, postId, post) => {

        return await handleServiceResponse(async () => {
            const options = {
                url: `${config.API_ADDR}/blogs/${blogId}/posts/${postId}`,
                method: 'PUT',
                data: post
            };

            const { data } = await axios(options)
            return data;
        });

    }

    static importAll = async (blogId, categoryId) => {
        return await handleServiceResponse(async () => {
            const options = {
                url: `${config.API_ADDR}/account/import`,
                method: 'PUT',
                data: {
                    blogId,
                    categoryId
                }
            };

            const { data } = await axios(options)
            return data;
        });
    }

    static moveToBlog = async (postId, blogId, destBlogId, destCategoryId) => {
        return await handleServiceResponse(async () => {
            const options = {
                url: `${config.API_ADDR}/blogs/${blogId}/posts/${postId}/move`,
                method: 'PUT',
                data: {
                    blogId: destBlogId,
                    categoryId: destCategoryId
                }
            };

            const { data } = await axios(options)
            return data;
        });
    }

}
